export function SubBotExitViewConstructor(services, callbacks, context, siteTypeConfig) {
  
  let joint = services.joint;

  return joint.shapes.html.AbstractElementView.extend({

    isElementEditable: false,

    angularTemplate: `
<div layout="row">
  <span ng-if="elementData.exitType === 'failure'" translate-once="parameters/quick_replies/details/graph/subbot_box_failure_exit"></span>
  <span ng-if="elementData.exitType !== 'failure'">{{ elementData.description }}</span>
</div>
`,

  });
}
